import axios from 'axios';
import { BASE_URL } from './constants';

export const axiosInstance = axios.create({ baseURL: BASE_URL, withCredentials: true });

export const dynamicFormsAxiosInstance = axios.create({ baseURL: BASE_URL, withCredentials: true });

dynamicFormsAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      sessionStorage.setItem('redirectUrl', window.location.pathname);
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
